import { Dropdown } from "./Dropdown";
import { useStateWithSearchParams } from "../../../hooks";

type Props = {
  query: string;
  items: string[];
  label: string;
  placeholder: string;
  maxHeight?: string;
  maxItemsWidth?: string;
  initSelected?: string;
};

type SearchParams = {
  [key: string]: string | undefined;
};

export const DropdownWithQuery = ({
  query,
  items,
  label,
  placeholder,
  maxHeight = "124px",
  maxItemsWidth = "100%",
  initSelected = "",
}: Props) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      [query]: undefined,
    },
  );

  return (
    <Dropdown
      label={label}
      placeholder={placeholder}
      selectedItem={{ value: searchDict[query] ?? initSelected }}
      items={items.map((value) => ({ value }))}
      onChange={({ value }) => setSearchValue(query, value)}
      maxHeight={maxHeight}
      maxItemsWidth={maxItemsWidth}
    />
  );
};
